import { Camera, Thermometer, MapPin, AlertTriangle, Activity, Smartphone, LayoutDashboard, Package, Gauge, Navigation, BarChart3 } from 'lucide-react';
import './Technology.css';

const onTruck = [
  { Icon: Camera,       title: 'AI CCTV Monitoring',       desc: 'Cargo and driver safety surveillance with AI-powered alerts.' },
  { Icon: Thermometer,  title: 'Temp & Humidity Sensors',  desc: 'Real-time monitoring for medical-grade compliance (GDP/GDPMD).' },
  { Icon: MapPin,       title: 'GPS & Telematics',         desc: 'Live location tracking, route history, and ETA visibility.' },
  { Icon: AlertTriangle,title: 'Alcohol Sensor Detection', desc: 'Automatic driver sobriety checks before every trip.' },
  { Icon: Activity,     title: 'Driver Behaviour Monitor', desc: 'Speed, braking, and fatigue analytics for fleet safety.' },
  { Icon: Smartphone,   title: 'Smart Vehicle Dashboard',  desc: 'Cloud-connected display showing battery, status, and alerts.' },
];
const offTruck = [
  { Icon: LayoutDashboard, title: 'Real-Time Fleet Monitoring',  desc: 'Full visibility of every vehicle across your entire fleet.' },
  { Icon: Package,         title: 'Delivery Tracking & ETA',     desc: 'End-to-end delivery status with automated notifications.' },
  { Icon: Gauge,           title: 'Temperature Compliance',      desc: 'Automated alerts for any temperature deviation events.' },
  { Icon: Navigation,      title: 'Route Optimisation',          desc: 'AI-powered routing for efficiency, cost, and compliance.' },
  { Icon: BarChart3,       title: 'Data Analytics Dashboards',   desc: 'Fleet performance, savings, and ESG reporting in one place.' },
];

export default function Technology() {
  return (
    <section className="tech-section" id="technology">
      <div className="tech-header">
        <span className="section-label">Smart Logistics Platform</span>
        <h2 className="section-title">Technology That Delivers</h2>
        <p className="section-desc">
          Axion integrates vehicle hardware, IoT sensors, and cloud platforms to build a fully connected smart logistics network.
        </p>
      </div>
      <div className="tech-grid">
        <div className="tech-col">
          <h3 className="tech-col-title">On-Truck Technology</h3>
          {onTruck.map(({ Icon, title, desc }) => (
            <div key={title} className="tech-item">
              <div className="tech-item-icon"><Icon size={20} strokeWidth={1.7} /></div>
              <div>
                <p className="tech-item-title">{title}</p>
                <p className="tech-item-desc">{desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="tech-col">
          <h3 className="tech-col-title">Off-Truck Platform</h3>
          {offTruck.map(({ Icon, title, desc }) => (
            <div key={title} className="tech-item">
              <div className="tech-item-icon"><Icon size={20} strokeWidth={1.7} /></div>
              <div>
                <p className="tech-item-title">{title}</p>
                <p className="tech-item-desc">{desc}</p>
              </div>
            </div>
          ))}
          <div className="tech-compliance">
            <p className="tc-title">Compliance Standards</p>
            <div className="tc-badges">
              {['GDP','GDPMD','ISO 9001','HACCP','ESG'].map(b => (
                <span key={b} className="tc-badge">{b}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
